import { splitWords, sentenceCase } from './string';

/** Capitalise a camelCase or snake_case rating value, e.g. "requiresImprovement" → "Requires improvement". */
export const formatRatingLabel = (rating: string): string =>
  sentenceCase(splitWords(rating));

/** Format a distance for display, to one decimal place, e.g. 0.397 → "0.4 miles away". */
export const formatProviderDistance = (
  miles?: number | null,
): string | undefined => {
  if (miles == null) return undefined;
  const rounded = miles.toFixed(1);
  return `${rounded} ${rounded === '1.0' ? 'mile' : 'miles'} away`;
};

interface ProviderPricing {
  pricePerWeek?: number | null;
  hourlyRate?: number | null;
}

/** Format a provider price for display, e.g. { pricePerWeek: 1250 } → "£1,250/week". */
export const formatProviderPrice = ({
  pricePerWeek,
  hourlyRate,
}: ProviderPricing): string | undefined => {
  if (pricePerWeek != null) return `£${pricePerWeek.toLocaleString()}/week`;
  if (hourlyRate != null) return `£${hourlyRate}/hour`;
  return undefined;
};
